export const liveScheduleActionsMenu = ["Post Schedule"];

export default liveScheduleActionsMenu;


// WEBPACK FOOTER //
// ./src/Components/Schedule/utils/live-schedules/drop-down-tables/liveScheduleActionsMenu.js